(function () {
  function getStorageKey() {
    return 'infiniteScrollState:' + window.location.pathname + window.location.search;
  }

  function getLoadedPage() {
    var container = document.querySelector('.collection__container');
    var page = container && parseInt(container.getAttribute('data-loaded-page'), 10);
    return page || 1;
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(getStorageKey());
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveState() {
    try {
      sessionStorage.setItem(getStorageKey(), JSON.stringify({
        page: getLoadedPage(),
        scrollY: window.pageYOffset || document.documentElement.scrollTop
      }));
    } catch (e) {}
  }

  function clearState() {
    try {
      sessionStorage.removeItem(getStorageKey());
    } catch (e) {}
  }

  function fetchAndAppend(url) {
    return fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        var container = document.querySelector('.collection__container').lastElementChild;
        var newInner = parsed.querySelector('.collection__container').innerHTML;
        container.insertAdjacentHTML('afterend', newInner);

        var pageMatch = url.match(/[?&]page=(\d+)/);
        var loadedPage = pageMatch ? parseInt(pageMatch[1], 10) : getLoadedPage() + 1;
        document.querySelector('.collection__container').setAttribute('data-loaded-page', loadedPage);

        var oldBtn = document.querySelector('infinity-button');
        var newBtn = parsed.querySelector('infinity-button');
        if (oldBtn && newBtn) oldBtn.replaceWith(newBtn);

        return loadedPage;
      });
  }

  function isBackForwardNavigation() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return nav ? nav.type === 'back_forward' : false;
  }

  var restoreTriggered = false;
  function restoreScrollState() {
    if (restoreTriggered) return;
    restoreTriggered = true;

    var state = readState();
    if (!state || !state.page || state.page <= getLoadedPage()) {
      clearState();
      return;
    }

    var loader = document.querySelector('.collection_facets_loader');
    if (typeof placeCollectionLoader === 'function') placeCollectionLoader();
    loader && loader.classList.add('loading_now');

    function step() {
      var btn = document.querySelector('infinity-button .btn');
      if (!btn || getLoadedPage() >= state.page) {
        loader && loader.classList.remove('loading_now');
        clearState();
        requestAnimationFrame(function () {
          window.scrollTo(0, state.scrollY || 0);
        });
        return;
      }
      fetchAndAppend(btn.href).then(step);
    }
    step();
  }

  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      // Page came from bfcache: DOM already has previously loaded products,
      // browser just won't auto-scroll to it since scrollRestoration is manual.
      var state = readState();
      if (state && typeof state.scrollY === 'number') {
        requestAnimationFrame(function () {
          window.scrollTo(0, state.scrollY);
        });
      }
      return;
    }
    if (isBackForwardNavigation()) {
      restoreScrollState();
    } else {
      clearState();
    }
  });

  window.addEventListener('pagehide', saveState);

  window.__infinityScrollFetchAndAppend = fetchAndAppend;
})();

class infinityButton extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.btn');
    this.link&&this.link.addEventListener('click', this.handler.bind(this));
    this.classList.contains('autoscroll_yes') && window.addEventListener('scroll', this.autoscrollhandler.bind(this));
  }
  handler(event){
    event.preventDefault();
    if(this.destroyed) return false;
    placeCollectionLoader();
    document.querySelector('.collection_facets_loader').classList.add('loading_now');
    var url = event.currentTarget.href;
    window.__infinityScrollFetchAndAppend(url).then(() => {
      document.querySelector('.collection_facets_loader').classList.remove('loading_now');
    });
  }
  autoscrollhandler(){
    if(!this.link || this.destroyed) return false;
    if(!this.link.classList.contains('autoscroll')) return false;
    var contY = parseInt(this.link.parentNode.offsetTop);
    var wY = this.getWindowHeight()+this.getWindowTopY();
    if( contY <= wY ) {
      this.link.classList.remove('autoscroll');
      this.link.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
    }
  }
  getWindowHeight(){
    return window.innerHeight;
  }
  getWindowTopY(){
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  disconnectedCallback(){
    this.destroyed = true;
    this.remove();
  }
}
customElements.define('infinity-button', infinityButton);
